import * as React from 'react';

import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';

import { useConfirmationStore } from '@/components/dialog/confirmation.store';
import { Translation, useDynamicLocale } from '@/hoslog-intl';

import { exportCsvSingleFilePapa } from '@/lib/exportCsv';
import { Pagination } from '@/react-query/context/ApiClientContextController';
import { BasicStores } from '@/services/basicStores/basicStores.types';
import useBasicStoresMutation from '../hooks/useBasicStoresMutation';
import { getColumns } from './Column';

export function BasicStoreManagementTable({
  data,
  isLoading,
  pagination,
}: {
  data: BasicStores[];
  isLoading: boolean;
  pagination: Pagination;
}) {
  const pageCount = React.useMemo(
    () => Math.ceil((pagination.totalItems ?? 0) / (pagination.pageSize ?? 1)),
    [pagination.totalItems, pagination.pageSize],
  );
  const { mutate } = useBasicStoresMutation();

  const { mutateAsync: deleteStore } = useBasicStoresMutation();
  const { openConfirmation } = useConfirmationStore();
  const { t } = useDynamicLocale();
  const columns = React.useMemo(
    () => getColumns(mutate, deleteStore, openConfirmation, t),
    [mutate, deleteStore, openConfirmation, t],
  );

  const finalData = data?.map((item: BasicStores, index: number) => {
    return {
      SN: index + 1,
      StoreName: item.storeName,
      'StoreName Eng': item.storeNameEng,
      Prefecture: item.prefecture,
      'Mobile Number': item.telephone,
      Status: item.status,
      'Create Date': item.createdDate,
      'Update Date': item.updatedDate,
    };
  });

  function handleExport() {
    exportCsvSingleFilePapa(finalData, {
      format: 'YYYY/MM/DD HH:mm:ss',
    });
  }

  const { table } = useDataTable({
    data,
    columns,
    pageCount: pageCount,
    initialState: {
      sorting: [{ id: 'clubId', desc: true }],
    },
    meta: {
      title: <Translation id="storeManagement.basicStores.page.table.title" />,
      loading: isLoading,
      actionKey: 'exportCsv',
      actionDisabled: data?.length === 0,
      action: handleExport,
      totalPage: pagination.totalItems,
    },
    getRowId: (originalRow) => String(originalRow.clubId),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <>
      <DataTable table={table}>
        <DataTableToolbar />
      </DataTable>
    </>
  );
}
